import { AuthLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'

import JTExpressIntegrationCreateContainer from './JTExpressIntegrationCreateContainer'
import JTExpressIntegrationUpdateContainer from './JTExpressIntegrationUpdateContainer'

export default () => {
  return [
    {
      layout: AuthLayout,
      path: ROUTES.JT_EXPRESS_INTEGRATION_CREATE_PATH,
      component: JTExpressIntegrationCreateContainer
    },
    {
      layout: AuthLayout,
      path: ROUTES.JT_EXPRESS_INTEGRATION_UPDATE_PATH,
      component: JTExpressIntegrationUpdateContainer
    }
  ]
}
